const MAX_ZOOM = 150;
const ZOOM_BTN_STEP = 50;
const ZOOM_PINCH_STEP = 5;

const btnZoomIn = document.querySelector('[data-zoom-in]');
const btnZoomOut = document.querySelector('[data-zoom-out]');
const container = document.querySelector('[data-container]');
const imageBoundingBox = document.querySelector('[data-bounding-box]');
const image = document.querySelector('[data-image]');
const breakpoint = window.matchMedia('(max-width: 767px)');
const orientation = window.matchMedia('(orientation: portrait)');
let previousWidth = window.innerWidth;

let maxHeight = 0;

const enableButton = (btn) => {
  if (btn.hasAttribute('disabled')) {
    btn.removeAttribute('disabled');
  }
};

const disableButton = (btn) => {
  btn.setAttribute('disabled', 'disabled');
};

const resetZoom = () => {
  container.style.marginLeft = '';
  container.style.marginRight = '';
  imageBoundingBox.style.overflow = '';
  imageBoundingBox.style.paddingTop = '';
  imageBoundingBox.style.paddingBottom = '';
  imageBoundingBox.style.minHeight = '';
  image.style.width = '';
  image.style.left = '0px';
  image.dataset.zoom = '100';
  maxHeight = imageBoundingBox.clientHeight;
  document.documentElement.style.overflow = 'visible';
  enableButton(btnZoomIn);
  disableButton(btnZoomOut);
};

const firstZoom = () => {
  imageBoundingBox.style.minHeight = (imageBoundingBox.getBoundingClientRect().height).toFixed(2) + 'px';
  container.style.marginLeft = '-16px';
  container.style.marginRight = '-16px';
  imageBoundingBox.style.overflow = 'hidden';
};

const setNewPadding = () => {
  const delta = maxHeight - image.clientHeight;
  const newPadding = delta > 0 ? (delta / 2).toFixed(2) : 0;
  imageBoundingBox.style.paddingTop = newPadding + 'px';
  imageBoundingBox.style.paddingBottom = newPadding + 'px';
};

const zoomIn = (amount) => {
  image.dataset.zoom = +image.dataset.zoom + amount;
  image.style.width = image.dataset.zoom + '%';
  const imageLeft = imageBoundingBox.clientWidth / 2 - (image.clientWidth * 0.5).toFixed(0);
  image.style.left = imageLeft + 'px';

  setNewPadding();
};

const zoomOut = (amount) => {
  image.dataset.zoom = +image.dataset.zoom - amount;
  image.style.width = image.dataset.zoom + '%';
  const imageLeft = imageBoundingBox.clientWidth / 2 - (image.clientWidth * 0.5).toFixed(0);
  image.style.left = imageLeft + 'px';

  setNewPadding();
};

const onZoomInClick = () => {
  if (!container.style.marginLeft || container.style.marginLeft === '') {
    firstZoom();
  }

  enableButton(btnZoomOut);

  const zoom = image.dataset.zoom + ZOOM_BTN_STEP > MAX_ZOOM ? MAX_ZOOM - image.dataset.zoom : ZOOM_BTN_STEP;
  if (image.dataset.zoom < MAX_ZOOM) {
    zoomIn(zoom);
  }

  if (image.dataset.zoom === MAX_ZOOM.toString()) {
    disableButton(btnZoomIn);
  }
};


const onZoomOutClick = () => {
  enableButton(btnZoomIn);

  const zoom = image.dataset.zoom - ZOOM_BTN_STEP > 0 ? image.dataset.zoom - 100 : ZOOM_BTN_STEP;
  if (image.dataset.zoom > 100) {
    zoomOut(zoom);
  }

  if (image.dataset.zoom === '100') {
    resetZoom();
    disableButton(btnZoomOut);
  }
};


const onWindowResize = () => {
  if (breakpoint.matches) {
    // изменение ширины проверяется, потому что при скролле на мобилке срабатывает resize
    // из-за появления адресной строки
    if (previousWidth !== window.innerWidth) {
      resetZoom();
      previousWidth = window.innerWidth;
    }
  } else {
    // однократно сбросить зум при переходе на десктоп
    if (container.style.marginLeft !== '') {
      resetZoom();
    }
  }
};

const getTouchesDistance = (evt) => Math.hypot(evt.touches[0].pageX - evt.touches[1].pageX, evt.touches[0].pageY - evt.touches[1].pageY);

const moveImage = (delta) => {
  let newLeft = Number.parseInt(image.style.left, 10) - delta.x;
  if (newLeft > 0) {
    newLeft = 0;
  } else if (newLeft < imageBoundingBox.clientWidth - image.clientWidth - 10) {
    newLeft = imageBoundingBox.clientWidth - image.clientWidth - 10;
  }

  image.style.left = newLeft + 'px';
};

const onTouchStart = (evtStart) => {
  const MIN_PINCH_DELTA = 10;

  if (image.dataset.zoom !== '100' && orientation.matches) {
    document.documentElement.style.overflow = 'hidden';
  }

  let touchStart = null; // Точка начала касания
  let touchPosition = null; // Текущая позиция
  let startTouchesDistance = 0; // Начальное расстояние двойного касания
  let moveTouchesDistance = 0; // Конечное расстояние двойного касания

  let isMultitouch = false;

  if (evtStart.touches.length > 1) {
    evtStart.preventDefault();
    startTouchesDistance = getTouchesDistance(evtStart);
  }

  touchStart = {x: evtStart.changedTouches[0].clientX, y: evtStart.changedTouches[0].clientY};
  touchPosition = {x: touchStart.x, y: touchStart.y};

  const onTouchMove = (evtMove) => {
    if (evtMove.touches.length > 1) {
      evtMove.preventDefault();
      isMultitouch = true;

      moveTouchesDistance = getTouchesDistance(evtMove);
      if (startTouchesDistance && moveTouchesDistance && Math.abs(moveTouchesDistance - startTouchesDistance) > MIN_PINCH_DELTA) {
        if (moveTouchesDistance > startTouchesDistance) {
          if (!container.style.marginLeft || container.style.marginLeft === '') {
            firstZoom();
          }

          if (image.dataset.zoom < MAX_ZOOM) {
            zoomIn(ZOOM_PINCH_STEP);
          }

          if (image.dataset.zoom === MAX_ZOOM.toString()) {
            disableButton(btnZoomIn);
          } else {
            enableButton(btnZoomOut);
          }
        } else {
          if (image.dataset.zoom > 100) {
            zoomOut(ZOOM_PINCH_STEP);
          }

          if (image.dataset.zoom === '100') {
            resetZoom();
            disableButton(btnZoomOut);
          } else {
            enableButton(btnZoomIn);
          }
        }
      }
    }

    touchPosition = {x: evtMove.changedTouches[0].clientX, y: evtMove.changedTouches[0].clientY};

    const delta = {
      x: touchStart.x - touchPosition.x,
      y: touchStart.y - touchPosition.y,
    };

    touchStart = {x: touchPosition.x, y: touchPosition.y};

    if (!isMultitouch) {
      if (image.dataset.zoom !== '100') {
        moveImage(delta);
      }
    }
  };

  const onTouchEnd = (evtEnd) => {
    document.documentElement.style.overflow = 'visible';

    if (evtEnd.touches.length > 1) {
      moveTouchesDistance = getTouchesDistance(evtEnd);
      if (startTouchesDistance && moveTouchesDistance && Math.abs(moveTouchesDistance - startTouchesDistance) > MIN_PINCH_DELTA) {
        if (moveTouchesDistance > startTouchesDistance) {
          if (!container.style.marginLeft || container.style.marginLeft === '') {
            firstZoom();
          }

          if (image.dataset.zoom < MAX_ZOOM) {
            zoomIn(ZOOM_PINCH_STEP);
          }

          if (image.dataset.zoom === MAX_ZOOM.toString()) {
            disableButton(btnZoomIn);
          } else {
            enableButton(btnZoomOut);
          }
        } else {
          if (image.dataset.zoom > 100) {
            zoomOut(ZOOM_PINCH_STEP);
          }

          if (image.dataset.zoom === '100') {
            resetZoom();
            disableButton(btnZoomOut);
          } else {
            enableButton(btnZoomIn);
          }
        }
      }
    }

    const delta = {
      x: touchStart.x - touchPosition.x,
      y: touchStart.y - touchPosition.y,
    };

    if (!isMultitouch) {
      if (image.dataset.zoom !== '100') {
        moveImage(delta);
      }
    }

    imageBoundingBox.removeEventListener('touchmove', onTouchMove);
    imageBoundingBox.removeEventListener('touchend', onTouchEnd);
  };

  imageBoundingBox.addEventListener('touchmove', onTouchMove);
  imageBoundingBox.addEventListener('touchend', onTouchEnd);
};


const initZoom = () => {
  if (btnZoomIn && btnZoomOut) {
    maxHeight = imageBoundingBox.clientHeight;

    btnZoomIn.addEventListener('click', onZoomInClick);
    btnZoomOut.addEventListener('click', onZoomOutClick);

    imageBoundingBox.addEventListener('touchstart', onTouchStart);

    window.addEventListener('resize', onWindowResize);
  }
};

export {initZoom};
